import BehaviorConfig from '@/models/app-config/behavior/behavior'
import CartLoginDefaultNote from '@spa/components/pages/cart/components/login/default/CartLoginDefaultNote.vue'
import Vue, { VueConstructor } from 'vue'

import CartLoginMyColorNote from '../../components/login/mycolor/MyColorNote.vue'

export interface CartLoginTemplateParts {
  readonly note: VueConstructor
}

type DefaultTemplate = (opt?: Partial<CartLoginTemplateParts>) => (behavior: BehaviorConfig) => CartLoginTemplateParts
export const defaultTemplate: DefaultTemplate = (opt = {}) => behavior => ({
  note: defaultNote(behavior.groupLabel),
  ...opt,
})
const defaultNote = (hostName: string) => Vue.extend({
  components: { CartLoginDefaultNote },
  template: `<cart-login-default-note host-name="${hostName}" />`,
})

export const mycolorTemplate: CartLoginTemplateParts = {
  note: CartLoginMyColorNote,
}

export const vilbTemplate = defaultTemplate({
  note: defaultNote('美ラボ'),
})

export const fitowaTemplate = defaultTemplate({
  note: defaultNote('FITOWA'),
})

export const loadingTemplate: CartLoginTemplateParts = {
  note: Vue.extend({
    template: '<div></div>',
  }),
}
